import httpUtils from '../../utils/HttpUtils'

class StoreService {

  //获取卖场列表信息
  async list(pageNo = 1) {
    let result = null;
    try {
      result = await httpUtils.post('/mall/store/list', {pageNo})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //获取卖场列表信息
  async detail(id) {
    let result = null;
    try {
      result = await httpUtils.post('/mall/store/detail', {id})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

}
export default new StoreService()
